import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-index-historial-clinico',
  templateUrl: './index-historial-clinico.component.html',
  styles: []
})
export class IndexHistorialClinicoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
